import { isNull } from 'lodash';
import APIEndpoints from '../utils/apiEndpoints';
import AbstractService from './abstractService';

// Singleton instance
let instance = null;

const _SERVICE_UNAVAILABLE_ = new Error({ message : 'Service Unavailable' });

export default class AgencyService extends AbstractService {
	static setup(baseURL, options) {
		instance = new AgencyService(baseURL, options);
	}

	static getInstance() {
		return instance;
	}

	constructor(baseURL, options) {
		super(baseURL, options);
		this.endpoint = APIEndpoints.agencyOverview;
	}

	static getOverview(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._getOverview(...params);
	}

	static exportReport(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._exportReport(...params);
	}

	_getOverview({
		startDateRange,
		endDateRange,
		includeAll,
	}) {
		return this.get({
			endpoint    : this.endpoint,
			queryParams : {
				startDateRange,
				endDateRange,
				includeAll,
			},
		});
	}

	_exportReport({
		type,
		data,
	}) {
		return this.post({
			endpoint    : `${this.endpoint}/exportReport`,
			queryParams : { type },
			data,
		});
	}
}
